export default {
  payment: 'Counter',
  order: 'Order',
  paymentMethod: 'Payment Method',
  choosePaymentMethod: 'Select Payment Method',
  moreOptions: 'More Methods',
  bank: 'Bank',
  name: 'Name',
  enterCardOwnerName: 'Enter the cardholder name of your payment card',
  phoneNumber: 'Mobile',
  enterYourCardPhoneNumber: 'Enter the mobile phone number corresponding to your payment card',
  lowest: 'Lowest',
  highest: 'Highest',
  rmb: 'CNY',
  point: 'Point',
  enterCustomAmount: 'Enter amount',
  payAmount: 'Payment Amount',
  cardNumber: 'Card Number',
  enterCardNumber: 'Enter payment card number',
  payImmediately: 'Pay',
  have: 'Have',
  personSuccess: 'has successfully recharged',
  channelUnavailable: 'The Channel Unavailable',
  paymentType: 'Payment Types',
  orderUnavailable: 'The order does not exist',
  error: 'Error',
  requestAgain: 'The order already exists, please try again',
  orderNumber: 'Order Number',
  enterCardOwner: 'Enter the name of the payment bank card',
  enterRealName: 'Enter your real name',
  enterPhone: 'Enter your mobile number',
  enterAnInteger: 'Enter an integer',
  paymentSupport: 'Recharge support',
  requestTooFrequently: 'Orders are initiated too frequently',
  needToSlowlyRequest: 'Sorry, because you frequently placed orders but did not submit payment',
  waitFiveMinutes: 'Please rest for five minutes and try again, thank you for your cooperation',
  done: 'Done',
  chooseLanguage: 'Choose Language',
  en: 'English',
  vn: 'Vietnamese',
  cn: 'Simplified Chinese',
  tw: 'Traditional Chinese',
  copy: 'Copy',
  tips: 'Tips',
  scanQrcode: 'Scan the QR code or click to copy the address.',
  screenshotAndScript: 'To find the order number, please provide screenshots and postscript code.',
  orderInfo: 'Order Information',
  address: 'Address',
  scripts: 'Scripts',
  qrcode: 'QR Code',
  ipBlock: 'Your has been blocked, please contact your parent.',
  invalidName: 'No real-name authentication',
  paid: 'Payment successful',
  channelMaintain: 'The channel is under maintenance, please contact customer service',
  id_number: 'ID number',
  phone: 'Phone',
  formatWrong: 'format has wrong',
  mobilePlaceholder: 'fill your mobile number (e.g. 254123456789)',
  loading: 'Processing...',
  recreateOrder: 'The channel is currently unavailable. Please recreate the order',
  orderDetail: 'Order Detail',
  paymentWarning: 'Please make payment according to the information shown below',
  alipayAccount: 'Alipay Account',
  alipaySurname: 'Alipay Surname',
  alipayName: 'Alipay Name',
  alipayRealName: 'Alipay Real Name',
  paymentFlow: 'Payment Steps',
  pleasePayWithin: 'Please complete payment within',
  minute: 'min',
  second: 'sec',
  countdownSuffix: ', payment after deadline will not be credited',
  orderExpired: 'Order has expired',
  warmReminder: 'Reminder',
  copied: 'Copied',
  uploadProof: 'Upload Payment Proof',
  selectImage: 'Tap to select image',
  submitProof: 'Submit Proof',
  uploading: 'Uploading...',
  uploadSuccess: 'Upload successful',
  uploadFailed: 'Upload failed, please try again'
}



// WEBPACK FOOTER //
// ./src/locales/lang/en.js